export default __webpack_public_path__ + "static/media/image-9.3dd8637f.png";